// STEM Education Trust (SET) Mock Data

export const stats = {
  yearsActive: 8,
  studentsEngaged: "11,000+",
  industryExperts: "100+",
  foundersSupported: "25+"
};

export const firstGlobalFeatures = [
  { icon: "Globe", title: "190+ Countries", description: "Global participation" },
  { icon: "Trophy", title: "Olympics Style", description: "World-class event" },
  { icon: "Wrench", title: "Applied Learning", description: "Real-world building" },
  { icon: "GraduationCap", title: "YALE & MIT", description: "Supported program" },
  { icon: "Users", title: "Team of 5", description: "Age 14-18 years" },
  { icon: "Plane", title: "Global Exposure", description: "International platform" }
];

export const founders = [
  {
    id: 1,
    name: "Gagan Goyal",
    title: "General Partner @ IndiaQuotient | Founder @ ThinkLabs",
    image: "/assets/images/Gagan_Goyal.png",
    achievements: [
      "IIT Bombay graduate",
      "One of India's early STEM entrepreneurs",
      "Built entrepreneurship programs at IIT-B",
      "General Partner @ IndiaQuotient, backing India-focused startups",
      "Led multiple successful early-stage investments",
      "Currently an early-stage investor in the Indian startup ecosystem"
    ],
    linkedIn: "https://www.linkedin.com/in/gagangoyal/"
  }
];

export const mentors = [
  { id: 1, name: "Saieesh Gandhi", role: "Policy Leader", image: "/assets/images/Saieesh.jpg" },
  { id: 2, name: "Sumesh Jaiswal", role: "Technology Leader", image: "/assets/images/Sumesh.jpg" },
  { id: 3, name: "Priti Patel", role: "Industry Innovator", image: "/assets/images/Priti.jpg" },
  { id: 4, name: "Fahad Azad", role: "Robotics & Automation Expert", image: "/assets/images/Fahad.jpg" },
  // { id: 5, name: "Nilesh Shah", role: "Tech Entrepreneur", image: "/assets/images/Nilesh.jpg" },
  { id: 5, name: "Ashwin Shah", role: "STEM Educator & Innovator", image: "/assets/images/Ashwin.png" }
];

export const stemSkills = [
  "Analytical & Critical Thinking",
  "Problem Solving",
  "Technology Literacy",
  "Leadership & Team Management",
  "Self Management",
  "Stress Management"
];

export const supportFeatures = [
  {
    title: "Mentorship",
    description: "Teams work with mentors from STEM domain - from professors to practitioners for holistic learning.",
    icon: "Users"
  },
  {
    title: "1:1 Trainer",
    description: "Assigned trainer works full-time to help solve problem statements and provide guidance.",
    icon: "UserCheck"
  },
  {
    title: "Meet & Greet",
    description: "Teams meet leading startup founders and corporate leaders including founders of Ola, KukuFM, and leading VCs.",
    icon: "Handshake"
  },
  {
    title: "Sponsorship Support",
    description: "SET helps teams garner sponsors. Mobilized ₹2+ Crore over 8 years to support participation costs.",
    icon: "IndianRupee"
  }
];

export const personalityTraits = [
  { trait: "Cooperate with people", percentage: 93 },
  { trait: "Brainstorm & innovate", percentage: 92 },
  { trait: "Solve unexpected problems", percentage: 92 },
  { trait: "Develop goal plans", percentage: 90 },
  { trait: "Teach others", percentage: 92 },
  { trait: "Lead team projects", percentage: 80 },
  { trait: "Time management", percentage: 85 },
  { trait: "Use math practically", percentage: 79 }
];

export const selectionProcess = [
  { month: "Jan-Feb", title: "Applications Open", description: "100+ applications from students aged 14–18" },
  { month: "March", title: "Selection Process & FGC Problem Statement Release", description: "Task reviews + interviews - Top teams shortlisted" },
  { month: "April", title: "Robot Kits & Nationals Challenge Released", description: "Kits distributed, build begins" },
  { month: "May-June", title: "Build, Testing & National Finals", description: "India National Finals – winners decided - Team India – FGC 2026 & backup team selected" },
  { month: "July-Oct", title: "FGC 2026 Preparation & Outreach", description: "Intensive training - Outreach programmes & demonstrations" },
  { month: "November", title: "FIRST Global Competition (FGC 2026)", description: "Team India competes on the world stage" }
];

export const sponsors = [
  { name: "Poonawala Group", logo: "/assets/images/poonawala_group_.png" },
  { name: "Narayan Murthy", logo: "/assets/images/Narayan_Murthy.jpeg", isIndividual: true },
  { name: "DivyaSree", logo: "/assets/images/divyasree.avif" },
  { name: "Reva University", logo: "/assets/images/REVA_University.png" },
  { name: "Tata", logo: "/assets/images/tata_logo.png" },
  { name: "ICICI Prudential", logo: "/assets/images/icici_prudential.png" },
  { name: "Ola", logo: "/assets/images/ola.png" },
  { name: "Innoven Capital", logo: "/assets/images/innoven_capital.jpeg" },
  { name: "ACS College of Engineering", logo: "/assets/images/ACS_College_of_Engineering.png" },
  { name: "Prashanth Prakash", logo: "/assets/images/Prashanth_Prakash.jpg", isIndividual: true }
];

export const teamHighlights = [
  {
    year: "2019",
    title: "All Girls Team",
    description: "India's first all-girls team to represent at FIRST Global, breaking barriers in STEM.",
    quote: "This experience showed me that engineering has no gender boundaries.",
    image: "/assets/images/all_girls_team.png"
  },
  {
    year: "2022",
    title: "Team from Dharavi",
    description: "Students from Dharavi proved that talent knows no zip code, representing India on global stage.",
    quote: "We came from the streets of Dharavi but dreamed as big as the sky.",
    image: "/assets/images/dharavi_team.png"
  },
  {
    year: "2025",
    title: "ATAL Labs Team",
    description: "Team from ATAL Innovation Mission labs, showcasing government's STEM education impact.",
    quote: "ATAL Labs gave us the tools, SET gave us the platform to shine globally.",
    image: "/assets/images/ATAL_Lab_team.png"
  }
];

export const teamPerformance = [
  {
    year: 2026,
    location: "Goa, India",
    team: "Team India 2026",
    school: "PRATHAM Club & Community STEAM Initiative",
    problemStatement: "FIRE & RESCUE",
    image: "/assets/images/2026.jpg",
    homepageSliderOverrideImage: "/assets/images/2026.jpg",
    imagePosition: "center 20%",
    rank: "Team India 2026",
    medals: ["FTC Think Award", "FTC Innovate Award", "E-Yantra 2nd Place", "Codeavour 3rd Place"],
    mentors: ["Anay Kamat"],
    students: ["Avaneesh Phadte", "Sparsh Verlekar", "Dhruv Salgaonkar", "Anam Raza", "Soham Redkar"],
    sponsors: ["STEM Education Trust", "PRATHAM Club", "Equal Experts India"],
    quote: "Driven by genuine enthusiasm and a shared ambition to compete at the highest level, build technology-driven solutions, and inspire our community to embrace science and innovation.",
    story: `# Team India – FIRST Global Challenge 2026

FGC 2026 Team India is a group of five high school students, four boys and one girl, bound together by an unrelenting passion for robotics and STEM. They came together voluntarily, driven not by obligation, but by genuine enthusiasm and a shared ambition to compete at the highest level, build technology-driven solutions, and inspire their community to embrace science and innovation.

That passion is reflected in their record. The team has competed in the FIRST Tech Challenge (FTC), the World STEM and Robotics Olympiad (WSRO), Codeavour, and numerous local competitions, consistently earning awards and recognition. Beyond the competition floor, they conduct workshops, training programmes, and outreach sessions in partnership with schools and local institutions. Their work has been recognised at the highest levels of the state. The team has been felicitated by the Chief Minister and other government officials, and their story has been featured regularly in the news media.

---

# Student Profiles

## Avaneesh Phadte – Grade 9

Avaneesh Phadte is a curious and solution-oriented Grade 9 student with a keen interest in building STEM models from a young age. His work has inspired both his schoolmates and participants at various state-level events. He is currently part of a team of innovators working on a community utility project. He is also deeply interested in Artificial Intelligence and has won awards in AI quiz competitions. 

On the team, Avaneesh handles CAD design and supports mechanical construction. His contribution was directly recognised when the team won both the Think Award and the Innovate Award at FTC 2026. He aspires to build a career in AI and engineering design.

---

## Sparsh Verlekar

Sparsh Verlekar is an all-rounder with a natural flair for management. He handles resource management, planning, and external connections, allowing his teammates to focus on the core robotics work. His coordination keeps the team organised and competition-ready. 

Sparsh also brings valuable technical skills to the team, including hardware assembly, sensor integration, and solution testing. He approaches every challenge with logical thinking, creativity, and a structured problem-solving mindset. Beyond robotics, Sparsh is also a talented singer and was the winner of The Golden Voice of Goa, Season 2. He is particularly interested in the management and leadership aspects of technology projects.

---

## Dhruv Salgaonkar

Dhruv Salgaonkar is a grounded and focused student with a strong engineering mindset. He specialises in frugal innovation, finding smarter and more cost-effective ways to improve robot performance. He is highly skilled in CAD design and robot building, and plays an important role in developing and improving the team’s robots. 

Dhruv also shares his knowledge by mentoring other students from Goa who are beginning journeys similar to his own. He mentored a team of two school students from Goa who went on to win third place in the Robo Soccer event at the Codeavour 7 International competition in Jakarta. As one of the team’s key members in robot development, Dhruv also serves as a driver and human player during matches. He hopes to pursue engineering and apply his problem-solving approach to real-world challenges.

---

## Anam Raza

Anam Raza is a passionate young innovator who began her robotics journey at a very young age. Technical excellence, purposeful innovation, and a deep sense of responsibility towards her team and community define everything she does. Judges have consistently praised her communication skills and attention to detail. 

Her individual achievements include second place at the national level in the E-Yantra Challenge conducted by IIT Bombay in 2026, a global top-10 finish in the Scratch Olympiad, and first place internationally in the block coding competition conducted by Discovery Edutech, along with numerous other national and international accolades. Beyond competitions, Anam regularly conducts block coding workshops for younger children and has self-published two books for children. On the team, she leads strategy, supports programming, and manages communication and social media. She aspires to pursue a career in technology and continue mentoring young coders.

---

## Soham Redkar

Soham Redkar is a passionate robotics enthusiast with a deep interest in machines, engineering, and innovation. He is at the heart of the team’s robot-building and driving efforts. As both a programmer and a driver, Soham has significantly improved the team’s performance on the competition field. He hopes to continue building and driving robots, deepen his programming skills, and ultimately pursue a career in robotics focused on addressing real-world challenges.

---

# Mentor & Community Ecosystem

## Anay Kamat – Team Mentor

Anay Kamat, the team’s mentor, has worked in the technology field for over 20 years and currently serves as a Lead Consultant at Equal Experts (India) Pvt. Ltd. Alongside his professional career, he has been actively involved in community initiatives that promote technology, coding, and robotics among young students in Goa. 

He was part of an early effort to demonstrate how Raspberry Pi computers and Linux could provide schools with an affordable and practical alternative to the costly and bulky desktop computers commonly used in school laboratories at the time. This initiative contributed to wider discussions on the use of open-source technology in education and the revision of Goa’s ICT curriculum for Standards IX and X, which introduced Scratch programming and greater use of open-source software. 

He has also guided the CARES (Coding and Robotics Education in Schools) team in developing its curriculum and implementation strategies. Through PRATHAM Club, he mentors student robotics teams and works with other community members to organise the Goa Regionals of Codeavour and the World STEM and Robotics Olympiad, along with workshops and training programmes that make competitive robotics more accessible to students across the state.

---

## Parent-Led STEAM Community Model

A defining strength of the team’s journey has been the active involvement of parents. With no professional robotics coaching institutes in Goa, parents have come together to support not only their own children, but also other young learners by sharing knowledge, arranging resources, guiding practice sessions, and encouraging teams through both success and failure. 

Over time, this has developed into a unique community-led STEAM model in which parents, mentors, teachers, and students learn from one another and work collectively. This collaborative approach has helped make robotics more accessible and has created an environment where young innovators can grow through shared effort, encouragement, and practical mentoring.

---

# Team Synergy & Vision

Together, the five form a cohesive and complementary unit:
- **Avaneesh Phadte**: CAD design, mechanical construction, communication, outreach, and judging rounds.
- **Sparsh Verlekar**: Planning, external connections, inventory, resources, communication, and solution testing.
- **Dhruv Salgaonkar**: Robot construction, CAD design, driver, and human player.
- **Anam Raza**: Strategy, programming, communication, social media, outreach, and judging presentations.
- **Soham Redkar**: Robot construction, programming, driving, and resource management.

Their collective ambition goes beyond winning. They aspire to become a model team that inspires others to take up robotics and motivates young minds to explore this exciting field. They aim to achieve this first by excelling themselves and then by mentoring others and building products and solutions that create meaningful social impact.`
  },
  {
    year: 2025,
    location: "Panama City, Panama",
    team: "Team India 2025",
    school: "ATAL Innovation Mission Labs",
    problemStatement: "ECO EQUILIBRIUM",
    homepageSliderOverrideImage: "/assets/images/DSC08165.JPG",
    imagePosition: "center",
    rank: "Rank 33rd",
    medals: ["Social Media Challenge Award"],
    mentors: ["Saieesh Gandhi", "Akhil Arun Menon"],
    students: ["Ningaraj", "Arjun", "Parshuram", "Chandan", "Gouresh"],
    sponsors: ["Divyasree", "Reva University", "ACS college of Engineering", "Prashant Prakash"],
    quote: "Building solutions for a sustainable future through robotics.",
    story: `# Announcing Team India – FIRST Global Challenge 2025

Representing the spirit of resilience, innovation, and aspiration, Team India for the FIRST Global Challenge 2025 is a handpicked team of five brilliant students from government schools in Bengaluru. Despite their modest upbringings, these students have broken barriers through the power of hands-on STEM learning. With the nurturing ecosystem of the Atal Tinkering Lab (ATL) at Government High School (GHS), 18th Cross, Malleswaram and the advanced support of the Amazon Future Engineer Makerspace Lab—run by The Innovation Story—these young minds are ready to compete on the global stage of robotics and innovation.

Each member carries a powerful story of overcoming odds, seizing opportunities, and reimagining what’s possible when the right support meets the right intent. Team India for the FIRST Global Challenge 2025 is not just a group of students—it’s a story of transformation. It is a team woven together by resilience, curiosity, and the shared belief that innovation should know no economic boundaries. These five students, all from government schools in Bengaluru, Karnataka, represent not only themselves but also thousands of other young dreamers from underserved communities across India.

Each member of the team brings a distinct strength to the table—be it mechanical design, coding, electronics, or strategic thinking—but what binds them is their collaborative spirit. They have learned to think together, build together, and fail together—only to rise again with stronger ideas and greater synergy. Their journey hasn’t been easy. Coming from homes where parents work as housekeeping staff, garment workers, and civil contractors, access to high-end technology or private coaching was never an option. But what they lacked in resources, they made up for in grit, curiosity, and an unrelenting drive to learn.

Their transformation began at the Atal Tinkering Lab in their school, where they were first exposed to the magic of hands-on STEM education. There, they lit their first LEDs, coded their first sensors, and assembled their first robots. But it was at the Amazon Future Engineer Makerspace, operated by The Innovation Story, that their raw potential was sharpened into competition-grade skill. Under guided mentorship, they dived deeper into CAD, system integration, wireless communication, and competitive robotics. From breadboards to Bluetooth, from LEGO kits to precision servo motors—they explored every aspect of engineering with both wonder and purpose.

What makes Team India truly special is their balance of humility and hunger. These are not just students who want to “build a robot”—they are learners who want to understand why it works, how it can be made better, and what problem it can solve for society. Their conversations are filled with debates about gear ratios and sensor calibration, but also with laughter, cultural pride, and big dreams—dreams of becoming engineers, scientists, and change-makers. Together, they have built more than a machine. They have built trust, communication, leadership, and a model of what inclusive innovation looks like. They are not just a team; they are a movement—a reminder that brilliance exists in every corner of our country, waiting for the right spark to ignite.

Team India is ready—not just to compete, but to inspire.

---

## Rising Through the Coral Reef Challenge – How Team India Was Formed

The road to the FIRST Global Challenge wasn’t handed to these students—it was earned through hard work, teamwork, and an extraordinary display of problem-solving. The selection process for Team India centered around the Coral Reef Challenge, a simulation-based robotics task that required students to conceptualize, design, and build a robot capable of collecting coral samples – Seahorse and deposit into Coral Reef demanding precision, reach, speed, and control. The students began with what they knew: VEX kits-based prototypes. Their initial plan was to build a telescopic arm using a rack-and-pinion mechanism. However, they quickly discovered that real-world constraints—like bulky motors, inadequate torque, and limited lift range—made their original idea unviable. Rather than giving up, they pivoted. That failure became the foundation for deeper learning.

Drawing from the materials around them and their growing Maker skills, they designed a custom robot from scratch. Using Johnson motors, acrylic sheets from their school lab, and metal column bars, they developed a pulley-driven telescopic arm system. The structural parts were fabricated in-house using a 3D printer at the AFE Makerspace.

They then took on a bigger challenge—Arduino Mega integration with BTS7960 motor drivers, allowing for finer control of high-torque motors. The robot, once just an idea, became a fully operational prototype—app-controlled, modular, and competition-ready.

But it wasn’t just the technology that made them stand out—it was the way they collaborated. Ningaraj and Arjun led mechanical design and CAD modeling; Gouresh handled Arduino programming and app integration; Chandan brought the circuits to life with electronics work; and Parashuram, with an eye for control and intuition, became the team’s official driver and UI tester. Each member played their part, filled gaps for one another, and mentored each other along the way. By solving the Coral Reef Challenge through innovation, grit, and synergy, this team earned more than a place at FGC—they earned each other’s trust, and the honor of representing a billion hopes on the world stage.

---

# Student Introduction

---

## Ningaraj – Grade 11

**School:** Government PU College, 18th Cross, Malleshwaram
**Mother:** Ms. Gowri – Housekeeping Staff

Raised by a single mother who works as housekeeping staff, Ningaraj’s story is one of pure perseverance. With his younger brother still in school, the responsibility he carries at home hasn’t dimmed his spirit—only fuelled it. Ever since he could hold a screwdriver, Ningaraj has been fascinated by machines and the way they function. His formal journey in electronics began in the Atal Tinkering Lab of GHS Malleswaram, where he went from lighting his first LED to understanding circuit logic and building basic machines. His learning deepened at the AFE Makerspace Lab, where he moved from curiosity to capability—learning to prototype mechanical systems, work with Arduino boards, and solve real-world problems. He dreams of becoming a mechanical engineer, and with his strong foundation in practical engineering, he’s on the path to make that a reality. Calm, observant, and focused—Ningaraj is the mechanical backbone of the team.

---

## Parashuram M. – Grade 11

**School:** Government High School, 18th Cross, Malleshwaram
**Mother:** Shanthamma – Garment Worker
**Father:** Manjunath – Civil Contractor

Parashuram comes from a home where both parents work long hours to provide for their children’s education. But that hasn’t stopped him from dreaming big. His journey with robotics started in 8th grade when he walked into the ATL Lab and was introduced to Arduino, sensors, and drones. Since then, his hunger for learning has only grown stronger. Known for his patience and analytical mindset, Parashuram quickly picked up how to integrate sensors, write basic code, and build smart devices. His quiet confidence belies a strong technical mind. With continued exposure at the AFE Makerspace, he expanded his skillset to include LEGO robotics, autonomous systems, and IoT concepts. He envisions a future in the robotics or automation sector and is already mastering the tools to get there. For Team India, Parashuram is a trusted engineer and thinker—someone who turns theory into function.

---

## Arjun K Raj – Grade 11

**School:** Government PU College, 18th Cross, Malleshwaram
**Mother:** Uma D M – Urban Development Department
**Father:** Kantharaju C B – Office Manager, Mega Miles Bearing Cups Pvt. Ltd.

Arjun’s journey is a beautiful blend of academic grit and athletic discipline. A consistent performer both in the classroom and on the sports field, Arjun has won accolades in Kabaddi and athletics while simultaneously building robots, circuits, and Arduino-based prototypes. Introduced to STEM through the ATL Lab in 9th grade, Arjun found his true calling in robotics. What sets him apart is his ability to apply lessons from sports—teamwork, discipline, resilience—to the world of innovation. His robots don’t just work—they reflect strategy and clarity. From line-followers to maze-solvers, his builds are known for precision. At the AFE Makerspace, he took a leap into system integration and competition readiness. Arjun is the team’s dynamic executor—agile, sharp, and solution-oriented.

---

## Gouresh K. – Grade 10

**School:** Government High School, 18th Cross, Malleshwaram
**Mother:** Ramya K – Homemaker
**Father:** Ravi K – Stock Trader & Partner, Religare Broking Ltd.

Gouresh’s story is one of early inspiration turning into structured ambition. Ever since 3rd grade, he was captivated by the idea of machines talking to each other—through code, through sensors, through logic. Although the lack of resources initially delayed his journey, things changed when he joined ATL at his government school. There, his passion found structure. At AFE Makerspace, it found wings. He became the team’s lead programmer, quickly mastering Arduino IDE, block coding, and logic structuring. Inspired by films and real-world computing applications, he envisions a future in aerospace engineering or cybersecurity. Today, he handles most of the system code for the Team’s robot, ensuring every servo and sensor is in sync. Gouresh represents the bridge between imagination and implementation.

---

## G. N. Chandan Raj – Grade 9

**School:** AVD High School, Karnataka
**Mother:** Ramya B – Language Teacher (Kannada, Hindi)
**Father:** G P Nagendra Kumar – Eye Technician

Chandan may be the youngest, but his talent is mature beyond his years. A true electronics enthusiast, he began his journey experimenting with batteries, resistors, and LEDs before mastering Arduino programming—all by the age of 13. He has built LDR-based lights, temperature monitors, and is currently working on an AI-enabled robot using TinkerCAD simulations. For Team India, he is the electronics brain—calm under pressure and always innovating.

---

# Atal Tinkering Lab, GHS Malleswaram – Where It All Began

The Atal Tinkering Lab (ATL) at Government High School, Malleshwaram, was established in October 2017 with the unwavering support of Dr. C. N. Ashwath Narayan, Hon. MLA of Malleswaram and former Deputy CM of Karnataka. It has since become a national model for grassroots innovation.

The lab has:
- Been consistently selected in the Top 300, Top 100, Top 50, and Top 6 of the Tinkering Marathon.
- Produced state-level winners in the Inspire Awards, Raman Awards, and National Innovation Challenges.
- Reached zonal and national levels of the First LEGO League.
- Launched student internships with IBM India, Atal Incubation Centre – Anantapur, and Dassault’s Seed the Future Program.
- Hosted sessions with legends like Mr. Vasagam (ISRO’s APPLE mission).
- Initiated “She Codes” for girl-led tech empowerment.
- Built India’s first school-run satellite ground station—the Puneet Ground Station.

It stands today as a beacon of what’s possible when government school students are given a platform to dream, tinker, and lead.

---

# Akhil Arun Menon – Mentor, Team India

Akhil Arun Menon is a passionate educator and technologist and the driving force behind Team India’s preparation for the FIRST Global Challenge. With a background in Electronics, Akhil holds a Master’s degree in Technology specialised in Embedded Systems, and currently pursuing his Doctoral Studies in the field of Computer Science and IoT with applications in Agriculture. He has spent over a decade at the intersection of education, innovation, and hands-on STEM learning, mentoring students from diverse socioeconomic backgrounds.

As a faculty member and content developer, Akhil has designed and delivered curricula in Robotics, IoT, Business Analytics, and Full-Stack Development. His research interests include STEM pedagogy in underserved communities, AI- driven educational tools, robotics education frameworks, and learning outcome modeling through maker-based interventions. He has contributed to national-level education programs, designed innovation labs, and has been a panelist on technology in education forums.

At the AFE Makerspace Lab in Bengaluru, Akhil leads student training in CAD, Arduino systems, electronics prototyping, and competitive robotics. His ability to connect deeply with students, simplify complex concepts, and foster innovation has transformed first-generation learners into confident global competitors. Under his mentorship, Team India has not only built a robot—but cultivated resilience, discipline, and vision.

---

# Amazon Future Engineer Makerspace – Powered by The Innovation Story

The Amazon Future Engineer Makerspace Labs, operated by The Innovation Story (TIS) in Bengaluru and Mumbai, serve as advanced innovation labs for government school students. Through this initiative, Amazon supports future-readiness by offering access to emerging technologies, project-based learning, and global platforms.

These Makerspaces are equipped with 3D printers, drones, AI modules, and robotics kits, and are led by mentors like Akhil Menon who blend industry insight with grassroots education. Hundreds of students have built real-world projects, won national awards, and some—like Team India—are now global contenders.

---

# The Innovation Story (TIS) – Engineering a Future for All

TIS is a national education innovation organization driving equitable STEM access. Through its tie-up with Amazon, TIS operates India’s flagship Amazon Future Engineer Labs, delivering high-impact learning to thousands of students. With a mission to bridge the opportunity gap, TIS blends community-driven mentoring with tech-enabled infrastructure. From training mentors to launching school-run satellite stations, TIS is rewriting what government school students can achieve—and Team India is living proof of that vision.

---

## Video

https://youtu.be/taKSeI1AN_0`,
    image: "/assets/images/20251004_063706210_iOS.jpg",
    images: [
      "/assets/images/20251004_063706210_iOS.jpg",
      "/assets/images/20251013_031529750_iOS.jpg",
      "/assets/images/20251004_055941096_iOS.jpg"
    ]
  },
  {
    year: 2024,
    location: "Athens, Greece",
    team: "Team India 2024",
    school: "Various Schools",
    problemStatement: "Feeding the Future",
    imagePosition: "center 40%",
    rank: "Rank 4th",
    medals: ["Zhang Heng Award for Engineering Design Bronze"],
    mentors: ["Mr. Nilesh Shah", "Mr. Saieesh Gandhi"],
    students: ["Jayanee", "Aryaman", "Aditi Shah", "Aarav Shah", "Sai Pranav Gandhi", "Arjun Kejriwal", "Neel Mistry", "Aarav Gupta"],
    sponsors: ["Reva University", "DivyaSree"],
    quote: "Every challenge at Athens taught us resilience and innovation.",
    story: `# Team India 2024

We are team India; a country with rich diversity. The diversity extends from Religion, Culture, Languages, Food Habits, Dressing etc. India is one of the oldest civilizations in the world with a kaleidoscopic variety and rich cultural heritage.

---

## Aarav Shah

Hi! I am Aarav Shah, Team India Captain. I have taken up the responsibility of steering our team with precision and passion! With a clear vision and an unwavering drive, I commit to meet every challenge with utmost passion and dedication. My journey into robotics started with a fascination for design and programming. With a strong background from doing FRC for 4 years, I aim to apply my skills in construction and programming to build a robot that excels. I’m thrilled to be part of the FGC India team and represent my country!!!

---

## Sai Pranav Gandhi

Hi, I am Sai Pranav Gandhi, Team India Driver. I have always admired F1 cars because of their advanced technology and cutting-edge engineering design! I am excited to be the driver of Team India and am looking forward to experiencing the same thrill and rush that F1 drivers feel when they drive a car. I am very passionate about robotics and STEM. As a kid, building toys piqued my curiosity and it sparked a passion for engineering in me. Since then, I have continued pursuing engineering and taken part in many competitions working hard and tenaciously each time. I am very excited to be a part of this team and will use this opportunity to work hard and give my best!!!

---

## Arjun Kejriwal

Hi, I am Arjun Kejriwal, Team India Pit Crew Lead. I have been fascinated by robotics since a young age. As the Chief of the Pit Crew, I’ll be in charge of doing the quick maintenance pit stops of our robot between the matches and to ensure it is in the most formidable condition. I have been intrigued by robotics and Lego since a young age. I am deeply humbled to be part of FGC Team India for this season. I would like to use my experience from FTC and WRO to excel my performance during this season. I look forward to participating in FGC and having enriching experiences. I wish to make India proud on the international stage.

---

## Neel Mistry

Hello I am Neel Mistry, Team India Spokesperson. I consider robotics as a high-stakes sport, driven by the thrill of competition. Team India faces many challenges, but we tackle each one head-on. We share our solutions so others can benefit from our experiences, ensuring a smoother path for future enthusiasts. I have taken up Robotics as a competitive sport rather than a casual hobby because of the heady mix of adventure and thrill. I love to share the engaging stories of challenges that Team India faced. I am honoured to be a part of Team India and look forward to a great season ahead with all teams at FGC.

---

## Aarav Gupta

Hi, I’m Aarav Gupta, Chief Designer, Team India. I want to build our Robot to perform at its best consistently. I wish to design, assemble, diagnose, and fix issues swiftly, keeping our robot reliable and efficient. I shall strive for meticulous attention to detail to drive our team towards success in this global competition. From a young age, I’ve been fascinated by robotics, diving into summer camps and LEGO courses. I’ve competed in FTC, FRC, and WRO, and participated in various hackathons. I have a basic grasp of CAD, Python, HTML, Arduino, and Java. Excited to support mechanical construction and maintenance with Team India, and eager to learn more.

---

## Nilesh Shah

Hi! I am Nilesh Shah, Chief Mentor, Team India.  
I would be responsible for managing team operations and developing strategies keeping the Team highly motivated all along. My experience of mentoring FIRST teams for over 10 years will help me in ensuring that Team India puts in their most focused and determined efforts while making the best of all the learning opportunities and building a great network of FIRST Community across the Nations. We shall strive hard to live by our motto of “Winning Hearts By Winning Efforts”.

---

## Saieesh Gandhi

Namaste as a STEM advocate and the driving force behind Goa’s robotics revolution, my journey began in 2019, fueled by a desire to spark my son’s interest in robotics. This ignited a passion that led him to mentor numerous teams in prestigious competitions like FLL, WRO, Makex, FTC, and FRC. Witnessing the transformative power of STEM on my son and his peers, I founded Legogoa, a community club dedicated to fostering STEM awareness and introducing competitive robotics to Goa. My current role as manager for Team India mirrors the responsibilities of overseeing a high-performance F1 team, where strategic decision-making, resource management, and fostering a collaborative environment are crucial for success.

---

## Video

https://youtu.be/gpeemYSXiYQ`,
    image: "/assets/images/2024.jpeg"
  },
  {
    year: 2023,
    location: "Singapore",
    team: "Team India 2023",
    school: "Various Schools",
    imagePosition: "center 10%",
    problemStatement: "Hydrogen Horizons",
    rank: "Rank 17th",
    medals: ["Clara Barton Award for Helping Hands Gold"],
    mentors: ["Mr. Saieesh Gandhi", "Mr. Sumesh Jaiswal"],
    students: ["Apurva", "Atharv", "Saipranav", "Venkatesh", "Viraj"],
    sponsors: ["TATA Technologies"],
    quote: "Singapore opened our eyes to what global collaboration means.",
    story: `# Namaste

We are team India; a country with rich diversity. The diversity extends from Religion, Culture, Languages, Food Habits, Dressing etc. India is one of the oldest civilizations in the world with a kaleidoscopic variety and rich cultural heritage.

---

We are a group of 5 students who are elated to represent India @ the FIRST Global Challenge in Singapore. The team selected to represent India this year at FGC 2023 comprises four boys and one girl. Three students studying in class 8th are less than 14 years old which makes our team the YOUNGEST. We belong to Team Legogoa, a parents-led community club that has been pursuing robotics for the past 6 years and has won multiple National and International awards. We were selected after a tough selection process competing against experienced and veteran teams from other parts of the country. We built a contraption that flung a tennis ball 27mts using the concepts of projectile motion.

Our selection as Team India led to statewide congratulations from the Honourable Chief Minister of Goa and the Goa State Assembly (House of Representatives) and we were widely reported in the media. It sparked a zeal and enthusiasm in students in the entire state of Goa.

Traditionally the bigger states and cities of India have been areas for participation in the fields of robotics. Our team belongs to a small state that lacks STEM awareness and also the facilities such as robotics labs, coaching centres and veteran teams. We would like to ensure that our participation would make us the torchbearer for smaller regions in the country to pursue competitive robotics. We have planned our outreach activities to inspire the small town students.

---

## The team consists of:

### Apurva
Despite being my first time participating in a robotics competition, I would like to leverage my expertise in sketching and painting and bring in my creative talents to teamwork. I am also excited to be the only girl in the team and inspire girls to pursue STEM.

### Atharv
Photography is my Hobby, while I’m more passionate about Automobile design and modifications. I have been part of moonshot and tinker fests in the past. Since I am studying Mechanical Engineering, I aim to build a robot for FGC that is fit and has the least amount of time in the pit.

### Saipranav
Playing with toys has been a childhood passion which graduated to building robots and competing at various robotics competitions. FGC now provides me a platform to design a robot that can compete at the International level.

### Venkatesh
I have been part of multiple robotic competitions in the past and build apps. My mobile app that showcases my state of Goa allows me to express my coding and creative aspects. Documenting and outreach is what I love to do.

### Viraj
Programming has been my childhood passion and I have won multiple coding competitions. My mobile app for Dementia Patients won the top national prize and gave me a chance to interact with our Prime Minister Shri Narendra Modi. Programming, strategy and robot drive would be my focus area.

---

## Mentors

Mr Saieesh Gandhi is the mentor of Team Legogoa, he has been active in mentoring teams since 2019 in various robotics competitions. His diverse experience and hands-on approach has kickstarted the competitive robotics in the state of Goa, India.

Mr. Sumesh Jaiswal is the Technical mentor for the team. A graduate from IIT Kanpur, he has been actively involved in FIRST Robotics since 2012. His technical expertise and years of experience help the team to keep on learning.

Fahad Azad: Technical Mentor of FGC India team, has been an integral part of the team since 2017. With over 15 years of experience in STEM education, Fahad has conducted workshops for 20,000 students across 200 schools and universities. He is the founder of Robowars, Full-throttle, and Drone Race contests organized at IIT Mumbai’s “Techfest.” Fahad is an Ignite fellow from Stanford Graduate School of Business and has been mentioned in the MIT TR35 list of Innovators.

---

## Video

https://youtu.be/33hnw7qK5rA`,
    image: "/assets/images/2023.jpeg"
  },
  {
    year: 2022,
    location: "Geneva, Switzerland",
    team: "Dharavi Dream Team",
    school: "Municipal School, Dharavi",
    problemStatement: "Carbon Capture",
    imagePosition: "center 35%",
    rank: "Rank 29th",
    medals: ["Sofia Kovalevskaya Award for International Journey Gold"],
    mentors: ["Meenal Majumder"],
    students: ["Rohit Sathe", "Paras Pawade", "Nikhat Khan", "Sumit Yadav", "Pritam Thopate"],
    sponsors: ["ICICI Prudential"],
    quote: "We came from the streets of Dharavi but dreamed as big as the sky.",
    story: `We are a group of five dedicated members. We have got this opportunity to represent Team India in FGC 2022, and so we are working our level best each day and night to fulfil the hopes of our country. Every member in our team is super cooperative when it comes to teamwork.

We come from financially disadvantaged backgrounds and we thank FIRST Global India for supporting us. We travel long distances to reach our workspace — most of us have to travel more than 2 hours daily.

---

Our experience this year has been amazing. Through this journey in FGC 2022, we are learning many new things and enjoying ourselves throughout. We joined as colleagues, but we are a team and family today. Each of us came knowing nothing. So, we learned together — CAD, Programming, construction, problem solving. We are implementing our knowledge and we continue to learn and to teach. Every time we hit a roadblock on our robot, we spend hours together to overcome it – these are incidents that have made us proud and brought bright smiles. These will be cherished no matter what the outcome of this journey will be.

---

Some of our favorite moments are mentioned below.

- Rohit Sathe: “When I assembled the robot hanger”
- Paras Pawade: “When I could complete my driving practice in minimum time”
- Nikhat Khan: “When I learned how to use power tools”
- Sumit Yadav: “When our robot hanger worked properly”
- Pritam Thopate: “When I wrote code for the drive”

---

Being representative of India, we dedicate our efforts to meet the goal of bringing about a change and making this world a better place through STEM. Under the theme ‘Carbon Capture’, we are super excited for FGC 2022.

Through this journey we are getting the opportunity to meet people of different cultures all over the globe and building strong relationships and better communities. We are ready to rise and as FIRST Global Team India fly high, keep following us.

---

## Video

https://youtu.be/S_qn9-OXPdI`,
    image: "/assets/images/2022.jpeg"
  },
  {
    year: 2021,
    location: "Virtual (COVID-19)",
    team: "Team India 2021",
    school: "Various Schools",
    problemStatement: "Sustainable Solutions",
    rank: "Rank 12th",
    medals: ["First Global Grand Challenge Award in Economy Gold", "First Global Challenge Award in Economy Gold", "Outstanding Mentor Award"],
    mentors: ["Ashwin Shah"],
    students: ["Parth Bhawsar", "Yash Chaudhary", "Nisarg Banda", "Kumayl Plumber", "Ayaan Bhatt", "Arnav Shah", "Samarth Vora", "Ashish Chakaravorty", "Tvisha Soni", "Aarav Parikh", "Juned Khan"],
    sponsors: ["TATA Technologies"],
    quote: "Even a pandemic couldn't stop our passion for robotics.",
    story: `We are 11 STEM fanatics from diverse backgrounds, age groups, and cities all over India – each armed with a unique spectrum of experience and skill – marching under a common vision to innovate, inspire and impact lives.

We are the team representing the youth of India at the prestigious 2021 FIRST Global Challenge, set out to innovate under the theme of “Discover & Recover” and channel are combined energy, skill, and enthusiasm into devising a practical solution to recover from the setback of the COVID-19 pandemic.

As the team representing the change-makers and future tech pioneers of India, we see it as our mission to inspire many others to rise to the challenge by setting a personal example.

Each day we work together ONLINE, we refuse to surrender to the off-putting effects of the pandemic – embracing our bond as a team which gives us the ‘जोश ’ (enthusiasm) to thrive in the face of adversity.

**WE ARE TEAM INDIA AND WE ARE COMING STRONG!**

---

## Video

https://youtu.be/wiRoSAIVSks?list=PL-RL-gR4GAff-nxphyg6PYkRF6n9tZ1Ov`,
    image: "/assets/images/2021.jpg"
  },
  {
    year: 2020,
    location: "Virtual (COVID-19)",
    team: "Team India 2020",
    school: "Various Schools",
    problemStatement: "Ocean Opportunities",
    rank: "Rank 5th",
    medals: ["Prize Package 3"],
    mentors: [],
    students: ["Anvesha Saraf", "Aaman Shah", "Ronav Jaiswal", "Anirudha Duttagupta", "Tanul Gupta", "Vianca Varma", "Anay Chauhan", "Yash Muthalia", "Sanjay Ramkumar", "Sanika Kale", "Aarrav Anil", "Gayatri Taware", "Snehal Gawai"],
    sponsors: ["Reva University"],
    quote: "Adapting to virtual competition taught us resilience beyond measure.",
    story: `> “It’s not that we use technology, we live technology,”

Team India is a diverse team of 13 members across 10000 kms.We belong to different states , regions, cultures and languages.

Our team comprises of students from different parts of India, students who had never met before. Our team includes Anvesha Saraf(Kolkata), Aaman Shah(Ahmedabad), Ronav Jaiswal(Pune), Anirudha Duttagupta(Kolkata), Tanul Gupta(Pune), Vianca Varma(Mumbai), Anay Chauhan(Pune), Yash Muthalia(Mumbai), Sanjay Ramkumar(Bengaluru), Sanika Kale(Akola), Aarrav Anil(Bengaluru), Gayatri Taware(Akola), Snehal Gawai(Akola).

Even in this pandemic we connect remotely and are united as a team.

All of us are extremely passionate about STEM and entered this competition with a can-do spirit.

Proudly holding the Indian flag we chant, “Vasudev Kutambka” which means the world is our family.

We believe we can together make the world a better place through STEM solutions.`,
    image: "/assets/images/unsplash-ocean-opportunities.jpg"
  },
  {
    year: 2019,
    location: "Dubai, UAE",
    team: "India Girls Team",
    school: "Various Schools - All Girls",
    problemStatement: "Ocean Opportunities",
    imagePosition: "center 40%",
    rank: "Rank 78th",
    medals: [],
    mentors: ["Meenal Majumder", "Priti Patel"],
    students: ["Aayushi Nainan", "Radhika Seksharia", "Jasmehar Kocchar", "Lavanya Iyer", "Aarushi Shah"],
    sponsors: ["Reva University"],
    quote: "This experience showed me that engineering has no gender boundaries.",
    story: `## AAYUSHI NAINAN

I primarily focus on outreach and programming in this team. For me, robotics has been more than just a hobby. Working collectively through hands-on challenges, FIRST exposed me to the fascinating world of STEM and robotics, motivating me to come out of my comfort zone and explore new ideas, without the fear of failing. In addition to contributing to my holistic development as a confident, diligent, and proactive girl, my involvement in outreach activities has taught me the importance of being humble. Similarly, I want to give back to society by creating a friendly environment where the youth of India, especially girls, can freely pursue STEM.

---

## RADHIKA SEKHSARIA

I focus on the fundraising and programming aspect of the FIRST Global competition!! From always describing myself as a “non-technical member” of a robotics team, to being a part of an all-girls team representing India at FGC 2019, STEM has taken over my interests and helped me grow holistically. With the expertise of video making, communication, writing, safety, and public speaking, I have contributed to various robotics teams and lead them to success. Over the years, I have also started developing my design, programming, and strategy skills, forming a well-rounded skill set. I am proud to be a part of team India as I get to spread the powerful message of every girl being capable of getting the same amount of respect and opportunity in the fields of science and technology. The chance to collaborate with the best of the world excited me to get my hands dirty and go full out to bring India to the top of the STEM community.

---

## JASMEHAR KOCCHAR

I primarily work on the programming and strategizing aspect of this competition. I have always been fascinated by sciences, especially astrophysics, from a very young age. I found my place within the astronomy clubs; however, I had always wanted to make something with a tangible form. This is where I stumbled onto robotics. My participation in just one FIRST program has opened my eyes to a boundless yet fascinating world of engineering and challenges. This experience has not only helped me hone my hard-technical skills but also improve my soft skills, like communication and public speaking. Through the powerful platform of the FIRST Global Challenge, I want to not only create awareness of such programs, but also help those who aren’t as privileged or are uncertain about the STEM field. I want to show that anything is possible with passion and determination.

---

## LAVANYA IYER

On my team, my focus is on robot construction and game strategy. I love technology and robotics because they give me a creative outlet and a chance to approach problems in new ways. In order for us to keep pace with the changing environment, which is getting increasingly permeated by Science, Technology, Engineering and Mathematics, girls have to be a part of STEM. I want to help forge a path to the future, and so I became a part of Team India, to make a difference. Though the numbers are growing, there still lies a gender disparity in the field and STEM continues to be dominated by males. I hope to motivate more girls to pursue STEM by spreading awareness about it. I am excited to be a part of Team India, to encourage not just girls, but all girls in STEM and change their lives on this pathway to a better tomorrow.

---

## AARUSHI SHAH

I work on Robot Design and Construction and Electricals in my team. From a young age, I have been fascinated by how things work the way they do. I loved working with my hands and was always either taking something apart or building something. Ideas and questions would ricochet in my head all day, and this boundless inquisitiveness found an outlet for expression when I discovered robotics. After participating in FIRST LEGO® League competitions in the 5th grade, there was no stopping me. Since then, I have been a part of multiple teams for multiple competitions, including FTC and FRC. Throughout these competitions, I have noticed a severe lack in the number of girls, especially on the technical side. I aim to erase this gender gap by inspiring the multitude of girls who I know are capable of so much more! Through Team Geared Up Girls, I want to encourage the youth and girls to pursue STEM, and prepare the next generation for the future.

---

## MEENAL MAJUMDER

I was introduced to this program when my daughter participated in FRC. I have been an Outreach and Awards mentor with the first FRC team from India for over 4 years. I enjoy STEM outreach and inspiring the next generation to explore STEM fields. As a mentor with 2 FRC teams, I have really enjoyed engaging with high school students and watching them problem solve. I love my role as a mentor, as every time I meet the students, I learn from them and they show me how bright the future is for STEM fields. I am a recipient of the Woodie Flowers Finalist Award at the Long Island regional in 2019.

---

## PRITI PATEL

Hello everyone! I am team manager. 10 years ago I was introduced to Robotics, and I fell in love with its idea and the science behind it – basically, STEM.  In order to fulfil my passion, I got into robotics and started introducing the idea to schools as a curriculum and to get them to step up Robotic labs within their campuses. Later I  got into deeper discussions with the school heads and owners / trustees of the schools in order to set up schools based around the concepts of STEM Education. Along the way, I was introduced to FIRST Global and got involved in setting up FIRST Global India and helping in selecting Team India to represent the country at the FIRST Global Challenges in 2017 in the USA, 2018 in Mexico, and now 2019 in Dubai.

---

## Video

https://youtu.be/1GLUA_jKoIg`,
    image: "/assets/images/2019.jpg"
  },
  {
    year: 2018,
    location: "Mexico City, Mexico",
    team: "Team India 2018",
    school: "Various Schools",
    problemStatement: "Access to Clean Water",
    imagePosition: "center 40%",
    rank: "Rank 58th",
    medals: ["Clara Barton Award for Helping Hands Gold", "Mansa Musa Award for Fundraising", "Safety Award"],
    mentors: ["Mr. Sumesh Jaiswal"],
    students: ["Rayushka", "Vivek", "Anika", "Vaastav", "Prerna"],
    sponsors: ["TATA Technologies"],
    quote: "Our first international robotics journey - the beginning of something big.",
    image: "/assets/images/2018.jpg"
  },
  {
    year: 2017,
    location: "Washington D.C., USA",
    team: "Team India 2017",
    school: "ThinkLabs Academy",
    problemStatement: "Clean Energy",
    rank: "Rank 18th",
    medals: ["FIRST Global Challenge Award Bronze", "Zhang Heng Award for Engineering Gold"],
    mentors: ["Mr. Nilesh Shah"],
    students: ["Rahesh", "Aadiv Shah", "Harsh Bhatt", "Vatsin", "Adhyyan", "Tejas", "Raghav"],
    sponsors: ["ThinkLabs"],
    quote: "The journey of a thousand robots begins with a single build.",
    image: "/assets/images/2017.jpeg"
  }
];

export const advisoryBoard = [
  { name: "Advisory Member 1", role: "Industry Expert", linkedIn: "#" },
  { name: "Advisory Member 2", role: "Education Leader", linkedIn: "#" },
  { name: "Advisory Member 3", role: "Corporate Advisor", linkedIn: "#" }
];

export const visionMission = {
  vision: "To see India consistently among the world’s top robotics nations, powered by accessible STEM opportunities for every student.",
  mission: "To identify, mentor, and empower high-potential students through national competitions, real-world problem solving, and global exposure",
  goals: [
    "Consistently positioned in Top 3 by 2030",
    "Host Robotics Olympics Finals in India",
    "Enable 100 learning centers across the country",
    "Run India-wide competitions across Robotics, AI, Drones, Space & Defense"
  ]
};

export const contactInfo = {
  email: "teamindiafgc2023@gmail.com",
  phone: "+91 80070 94101",
  address: ""//"A-402 Auram Heights, Opp Shivalik Green, Ambali Road, Ambali Ahmedabad 380058, Daskroi - 380058"
};

export const navLinks = [
  { name: "Home", path: "/" },
  {
    name: "About Us",
    path: "/about",
    children: [
      { name: "About SET", path: "/about" },
      { name: "FIRST Global Challenge", path: "/first-global-challenge" },
      { name: "FGC Nationals 2026", path: "/fgc-nationals-2026" },
      { name: "How We Help", path: "/how-we-help" },
      { name: "BYKM", path: "https://bykm.abacusai.app/", isExternal: true }
    ]
  },
  { name: "BYKM", path: "https://bykm.abacusai.app/", isExternal: true },
  { name: "Team Performance", path: "/performance" },
  { name: "Blogs", path: "/blogs" },
  { name: "Contact Us", path: "/contact" },
  { name: "Donate", path: "/donate" }
];

export const blogConfig = {
  // Specify a title string (or partial matching title) to pin a post as the Featured Hero Banner.
  // Set to null (or empty string) to automatically pin the most recent published post.
  pinnedPostTitle: null,

  // List of RSS feed sources to fetch, combine, and sort chronologically by date
  rssFeeds: [
    {
      id: "medium",
      name: "Medium",
      url: "https://medium.com/feed/@teamindiafgc",
      badgeColor: "bg-midnight text-white",
      defaultCategory: "ROBOTICS"
    }
  ]
};
